if not App.angularApp?
    return

App.angularApp.directive 'mfMentionToggle', () ->
    return {
        restrict: 'A'
        require: '^mfMentionContainer'
        link: (scope, elem, attrs, Cont) =>

            # Toggle is_open on click
            elem.on 'click', () =>
                if not Cont.get('is_open')
                    # reset pattern
                    # Cont.setPattern(null, true)
                    if Cont.get('text')? and Cont.get('text') isnt ''
                        Cont.setText(Cont.get('text') + ' @')
                    else
                        Cont.setText('@')

                    # focus cursor on message input
                    angular.element(Cont.input_elem).trigger('focus')
                else
                    Cont.setPattern(null, false)

    }
